import "../tailwind.css";
import "focus-visible";
import "react-toastify/dist/ReactToastify.css";
import "@hopin-team/ckeditor5-build-hopin/dist/styles.css";
// polyfills
import "polyfills/get-random-values";

import { LoggingProvider } from "@hopin-team/provider-logging";
import type { SentryEnv } from "@hopin-team/provider-logging/dist/types";
import getConfig from "next/config";
import Head from "next/head";
import { useRouter } from "next/router";
import * as React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import FeatureFlags from "@/components/feature-flags/feature-flags-component";
import store from "@/redux/store";
import GlobalStyles from "@/styles/global-styles";
import { initCKEditorLocalisation } from "@/utils/init-ckeditor-localisation";
import { initI18n } from "@/utils/initI18n";

const {
  publicRuntimeConfig: {
    SENTRY_RELEASE_VERSION,
    SENTRY_DSN,
    SENTRY_ENV,
    CONSUMER_ID,
    BASE_PATH,
  },
} = getConfig();

if (typeof window !== "undefined") {
  initI18n({ basepath: BASE_PATH });
}

initCKEditorLocalisation();

// eslint-disable-next-line react/prop-types
function App({ Component, pageProps }) {
  const router = useRouter();

  React.useEffect(() => {
    if (window.addeventatc) {
      const online = ' <span class="online">(online)</span>';
      window.addeventatc.settings({
        css: false,
        appleical: { show: true, text: "Apple Calendar" },
        google: { show: true, text: "Google" + online },
        office365: { show: true, text: "Office 365" + online },
        outlook: { show: true, text: "Outlook" },
        outlookcom: { show: true, text: "Outlook.com" + online },
        yahoo: { show: true, text: "Yahoo" + online },
      });
    }
  }, [router.pathname]);

  const getLayout = Component.getLayout || ((page) => page);

  return (
    <React.Fragment>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <GlobalStyles />
      <ToastContainer
        hideProgressBar={true}
        closeButton={false}
        autoClose={3000}
        position="top-center"
      />
      <FeatureFlags>
        <>
          <LoggingProvider
            sentryDsn={SENTRY_DSN}
            sentryEnv={SENTRY_ENV as SentryEnv}
            sentryRelease={SENTRY_RELEASE_VERSION}
            consumerId={CONSUMER_ID}
          >
            <Provider store={store}>
              {getLayout(<Component {...pageProps} />)}
            </Provider>
          </LoggingProvider>
        </>
      </FeatureFlags>
    </React.Fragment>
  );
}

export default App;
